import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useDateTime } from "../../../../../../localization/useDateTime"
import { MeetingDetailsOrder } from "../../../../../../nonAdminUser/reports/home/meetingServiceApi"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    tableHeader: {
        fontWeight: 500,
        color: theme.palette.tailwind.slate[500],
        fontSize: "1rem",
        whiteSpace: "nowrap",
    },
    tableCell: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1,
        [theme.breakpoints.down("sm")]: {
            padding: "1rem 0.5rem",
        },
    },
    idCell: {
        [theme.breakpoints.down("sm")]: {
            width: "3.625rem",
        },
    },
    timeCell: {
        [theme.breakpoints.down("sm")]: {
            width: "6.625rem",
        },
    },
    container: {
        display: "flex",
        flexDirection: "column",
    },
    tableContainer: {
        [theme.breakpoints.down("sm")]: {
            order: 2,
            marginTop: "4rem",
        },
    },
}))

type TableOrder = {
    id?: number
    items: number
    name: string
    deliveryTime?: string
}

interface OrderItemsTableProps {
    orders: TableOrder[]
    hideDeliveryTime?: boolean
}

export default function OrderItemsTable({ orders, hideDeliveryTime = false }: OrderItemsTableProps) {
    const { classes, cx } = useStyles()
    const dateTimeFactory = useDateTime()

    return (
        <Box className={classes.container}>
            <TableContainer className={classes.tableContainer}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <LocalizedStrict id="production-package-slip-table-column-items">
                                <TableCell className={classes.tableHeader} align="right">
                                    Items
                                </TableCell>
                            </LocalizedStrict>
                            <LocalizedStrict id="production-package-slip-table-column-products">
                                <TableCell className={classes.tableHeader}>Products</TableCell>
                            </LocalizedStrict>
                            {!hideDeliveryTime && (
                                <LocalizedStrict id="production-package-slip-table-column-delivery-time">
                                    <TableCell className={classes.tableHeader} align="center">
                                        Delivery time
                                    </TableCell>
                                </LocalizedStrict>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {orders.map((orderLine) => (
                            <TableRow key={orderLine.id}>
                                <TableCell className={cx([classes.tableCell, classes.idCell])} align="right">
                                    {orderLine.items}
                                </TableCell>
                                <TableCell className={classes.tableCell} sx={{ width: "100%" }}>
                                    {orderLine.name}
                                </TableCell>
                                {!hideDeliveryTime && (
                                    <TableCell className={cx([classes.tableCell, classes.timeCell])} align="center">
                                        {orderLine.deliveryTime
                                            ? dateTimeFactory.toHourMinute(
                                                  dateTimeFactory.fromApi(orderLine.deliveryTime),
                                              )
                                            : "-"}
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}
